import React, { Component } from "react";
import { Helmet } from 'react-helmet-async';
import "w3-css/3/w3.css";
import "./Weight.css";
import {
  FromGramsButton,
  FromOuncesButton,
  FromPoundsButton,
  FromStonesButton,
  FromKilogramsButton
} from "./Button";
import { getConversion } from "./weight/ConversionTracker";
import { trackConversion, trackButtonClick } from "../../utils/analytics";
export default class Weights extends Component {
  render() {
    return (
      <div>
      <Helmet>
        <title>Free Weight Converter - Convert Pounds, Kilograms, Grams & More | Kayannou</title>
        <meta name="description"
          content="Free online weight converter. Convert between pounds, kilograms, grams, ounces, and stones. Fast, accurate, and easy-to-use weight conversion tool." />
        <meta name="keywords"
          content="weight converter, weight conversion, pounds to kilograms, grams to ounces, weight calculator, unit converter, convert weight, free weight converter, online weight tool, grams, gram, ounce, ounces, pounds, pound, stone, stones, kilograms, kilogram" />
        <meta name="author" content="Kayannou" />
        <meta property="og:title" content="Free Weight Converter - Convert Pounds, Kilograms, Grams & More" />
        <meta property="og:description" content="Free online weight converter. Convert between pounds, kilograms, grams, and more. Fast and accurate." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Free Weight Converter - Convert Pounds, Kilograms, Grams & More" />
        <meta name="twitter:description" content="Free online weight converter. Convert between pounds, kilograms, grams, and more." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Weight Converter",
            "description": "Free online weight converter for pounds, kilograms, grams, and more",
            "url": "https://kayannou.com/conversion/weight",
            "applicationCategory": "UtilityApplication",
            "operatingSystem": "Any",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            }
          })}
        </script>
      </Helmet>
        <Container />
        </div>
    );
  }
}
class Container extends Component {
  state = {
    value: "",
    operation: ""
  };
  handleConversionButton = buttonId => {
    this.setState({ operation: buttonId });
    // Track button click
    trackButtonClick(`Weight: ${buttonId}`, 'Weight Conversion');
  };

  handleConversionValue = inputValue => {
    this.setState({ value: inputValue });
    // Track conversion when both value and operation are present
    if (inputValue && this.state.operation) {
      trackConversion('Weight', this.state.operation, 'multiple_units', inputValue);
    }
  };

  render() {
    return (
      <div className="weight-conversion-container">
        <div className="conversion-content">
          <ContainerHeader
            conversionValue={this.handleConversionValue}
            conversionresult={getConversion(
              this.state.value,
              this.state.operation
            )}
          />
          <MiddleColumn id="" conversionButton={this.handleConversionButton} />
        </div>
      </div>
    );
  }
}
class ContainerHeader extends Component {
  state = {
    inputValue: "",
    isFocused: false
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ inputValue: value });
    this.props.conversionValue(value);
  };

  handleFocus = () => {
    this.setState({ isFocused: true });
  };

  handleBlur = () => {
    this.setState({ isFocused: false });
  };

  clearInput = () => {
    this.setState({ inputValue: "" });
    this.props.conversionValue("");
    if (this.input) {
      this.input.focus();
    }
  };

  render() {
    let result = this.props.conversionresult;
    const { inputValue, isFocused } = this.state;

    return (
      <div className="conversion-header">
        <div className="conversion-container">
          {/* Input Section */}
          <div className="input-section">
            <div className="input-group">
              <label className="input-label">
                <i className="fa fa-balance-scale"></i>
                Weight Input
              </label>
              <div className={`input-wrapper ${isFocused ? 'focused' : ''} ${inputValue ? 'has-value' : ''}`}>
                <input
                  ref={input => (this.input = input)}
                  className="conversion-input"
                  onChange={this.handleChange}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                  value={inputValue}
                  name="weight"
                  type="number"
                  placeholder="Enter weight conversion..."
                  min="0"
                  step="any"
                />
                {inputValue && (
                  <button
                    className="clear-button"
                    onClick={this.clearInput}
                    type="button"
                    aria-label="Clear input"
                  >
                    <i className="fa fa-times"></i>
                  </button>
                )}
                <div className="input-border"></div>
              </div>
            </div>
          </div>

          {/* Result Section */}
          <div className="result-section">
            <div className="result-group">
              <label className="result-label">
                <i className="fa fa-calculator"></i>
                Conversion Result
              </label>
              <div className="result-display">
                {result ? (
                  <div className="result-content">
                    <span className="result-value">{result}</span>
                    <div className="result-indicator">
                      <i className="fa fa-check-circle"></i>
                    </div>
                  </div>
                ) : (
                  <div className="result-placeholder">
                    <i className="fa fa-arrow-left"></i>
                    <span>Enter value and select type</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Visual Enhancement */}
        <div className="header-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="decoration-line"></div>
        </div>
      </div>
    );
  }
}
class MiddleColumn extends Component {
  handleClickUnit = buttonId => {
    this.props.conversionButton(buttonId);
  };

  render() {
    return (
      <div className="conversion-buttons-section">
        <div className="buttons-header">
          <h3 className="section-title">
            <i className="fa fa-balance-scale"></i>
            Select Weight Unit
          </h3>
          <p className="section-description">
            Choose the weight unit you want to convert from
          </p>
        </div>

        <div className="conversion-buttons-grid">
          <FromGramsButton id="grto" grUnit={this.handleClickUnit} />
          <FromOuncesButton id="ozto" ozUnit={this.handleClickUnit} />
          <FromPoundsButton id="pdto" pdUnit={this.handleClickUnit} />
          <FromStonesButton id="stto" stUnit={this.handleClickUnit} />
          <FromKilogramsButton id="klto" klUnit={this.handleClickUnit} />
        </div>
      </div>
    );
  }
}
